import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import { PAGE_CONFIG } from './pageConfig';

const reqParams = '/monetization/adFunnel';

const AdFunnel: React.FC = () => (
  <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG as IPageConfigType} />
);

export default AdFunnel;
